import axios from 'axios'
import { cityUrl, getHeader } from '@/config'

const state = {
  cityList: []
}

const mutations = {
  SET_CITY_LIST (state, obj) {
    state.cityList = obj
  }
}

const actions = {
  getCityList: ({ commit }) => {
    axios.get(cityUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_CITY_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
